import { computed, ref, toValue, watch } from 'vue'
import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import { getAvatarPath } from '@/utils/avatar'

/** Uploaded avatars outlive their storage object, so probe the URL and treat a dead one as no avatar at all. */
export function useAvatarPath(
  avatar: MaybeRefOrGetter<string | null | undefined>,
  id: MaybeRefOrGetter<string | number>,
): ComputedRef<string> {
  const broken = ref(false)

  watch(
    () => toValue(avatar),
    (source) => {
      broken.value = false

      if (!source) return

      const probe = new Image()
      probe.addEventListener('error', () => {
        if (toValue(avatar) === source) broken.value = true
      })
      probe.src = source
    },
    { immediate: true },
  )

  return computed(() => getAvatarPath(broken.value ? null : toValue(avatar), toValue(id)))
}
